console.log('qlq??');

// Este script modifica el max-width de ._inline_stahb_47 ._formContainer_stahb_30 dentro de <form-embed>
(function () {
  const MAX_WIDTH = '1000px';
  let styleApplied = false;

  function applyCustomStyles() {
    const formEmbed = document.getElementById('app-embed');
    if (!formEmbed) {
      return false;
    }
    if (!formEmbed.shadowRoot) {
      return false;
    }
    const formContainer = formEmbed.shadowRoot.querySelector('._inline_stahb_47 ._formContainer_stahb_30');
    if (!formContainer) {
      return false;
    }
    formContainer.style.maxWidth = MAX_WIDTH;
    styleApplied = true;
    return true;
  }

  function waitForElementAndApply() {
    if (applyCustomStyles()) return;

    const observer = new MutationObserver(() => {
      if (styleApplied) {
        observer.disconnect();
        return;
      }
      if (applyCustomStyles()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForElementAndApply);
  } else {
    waitForElementAndApply();
  }
})();
